import React, { useEffect, useState } from 'react'

const nf = new Intl.NumberFormat('de-CH')

export const Summary = () => {
  const [data, setData] = useState<
    { cases: number; death: number } | undefined
  >()
  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard/countries_date/Welt.json?a=' +
        Math.random()
    )
      .then(response => {
        return response.json()
      })
      .then(data => {
        setData({
          cases: data.cumCases[data.cumCases.length - 1].v,
          death: data.cumDeath[data.cumDeath.length - 1].v
        })
      })
  }, [])
  return (
    <>
      <div className='summary'>
        {data && (
          <>
            <span className='countries'>
            &nbsp;
              {data.cases > 9999 ? nf.format(data.cases) : data.cases}{' '}
            </span>{' '}
            &nbsp;bestätigte Fälle und <br />
            <span className='death'>
              {' '}
              &nbsp;{data.death > 9999
                ? nf.format(data.death)
                : data.death}{' '}
             
            </span> &nbsp;Tote 
          </>
        )}
      </div>
    </>
  )
}
//countries_date/Welt.json
